module.exports = __webpack_public_path__ + "img/gamex-logo.0c03aa7a.png";